'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DragSource } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-ipeui-backend';
import { draggingStarted as draggingStartedAction, draggingStopped as draggingStoppedAction } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { getHoveredResizeHandleType } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import SolidColumnGridLine from 'layout-dnd-components/SolidColumnGridLine';
import { dragTypes } from 'InpageEditorUI/lib/layoutSection/constants';
import { layoutSectionHoverPositionsFrozen, layoutSectionHoverPositionsThawed } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { calculateResizeSteps } from 'InpageEditorUI/lib/layoutSection/resizeHandleHelpers';
import { getIsAnythingSelected } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { jsx as _jsx } from "react/jsx-runtime";
const dragSource = {
  beginDrag(props) {
    const {
      type,
      leftColumn,
      rightColumn,
      draggingStarted,
      setDragging
    } = props;
    setDragging(true);
    const resizeSteps = calculateResizeSteps(leftColumn, rightColumn);
    const dragItem = {
      type,
      resizeSteps,
      leftColumnId: leftColumn.id,
      rightColumnId: rightColumn.id
    };
    draggingStarted(dragItem);
    return dragItem;
  },
  canDrag(props) {
    return !props.isAnythingSelected;
  },
  endDrag(props, monitor) {
    props.setDragging(false);
    props.draggingStopped(monitor.getItem(), monitor.didDrop());
  }
};
const dragCollect = (dndConnect, monitor) => {
  return {
    connectDragSource: dndConnect.dragSource(),
    connectDragPreview: dndConnect.dragPreview(),
    isDragging: monitor.isDragging()
  };
};
const mapStateToProps = (state, ownProps) => {
  return {
    isAnythingSelected: getIsAnythingSelected(state),
    isResizeHandleHovered: getHoveredResizeHandleType(state) === ownProps.type
  };
};
class LayoutSectionResizeHandle extends Component {
  constructor(props) {
    super(props);
    this.getGridlineLeftPos = this.getGridlineLeftPos.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleNextMouseUpAnywhere = this.handleNextMouseUpAnywhere.bind(this);
  }
  componentDidMount() {
    const {
      connectDragPreview
    } = this.props;
    connectDragPreview(getEmptyImage(), {
      captureDraggingState: true
    });
  }
  getGridlineLeftPos() {
    const {
      isDragging,
      isResizeHandleHovered,
      gutterWidth
    } = this.props;
    const roundedLeft = Math.round(gutterWidth / 2);
    const isWiderLine = isDragging || isResizeHandleHovered; // 2px when active

    // Attempting to center the grid under the resize handle, might need tweaking
    if (isWiderLine || roundedLeft % 2 === 0) {
      return roundedLeft;
    }
    return roundedLeft - 0.5;
  }
  handleMouseDown() {
    this.props.layoutSectionHoverPositionsFrozen();
    window.addEventListener('mouseup', this.handleNextMouseUpAnywhere);
  }
  handleNextMouseUpAnywhere() {
    this.props.layoutSectionHoverPositionsThawed();
    window.removeEventListener('mouseup', this.handleNextMouseUpAnywhere);
  }
  render() {
    const {
      connectDragSource,
      isDragging,
      isResizeHandleHovered,
      shouldHide,
      gutterTop,
      gutterLeft,
      gutterHeight,
      gutterWidth,
      type
    } = this.props;
    const gutterStyles = {};
    if (shouldHide) {
      gutterStyles.display = 'none';
    } else {
      // The resize handle and grid line are positioned relative to the absolutely positioned gutter wrapper div
      gutterStyles.top = gutterTop;
      gutterStyles.left = gutterLeft;
      gutterStyles.width = gutterWidth;
      gutterStyles.height = gutterHeight;
    }
    const columnResizeHandle = /*#__PURE__*/_jsx(SolidColumnGridLine, {
      height: gutterHeight,
      isActive: isDragging || isResizeHandleHovered,
      left: this.getGridlineLeftPos(),
      top: 0
    });
    return connectDragSource( /*#__PURE__*/_jsx("div", {
      className: "hs-ls-gutter-resize-handle",
      onMouseDown: this.handleMouseDown,
      style: gutterStyles,
      children: /*#__PURE__*/_jsx("div", {
        "data-selenium": type,
        children: columnResizeHandle
      })
    }));
  }
}
LayoutSectionResizeHandle.contextType = TourContext;
LayoutSectionResizeHandle.propTypes = {
  connectDragPreview: PropTypes.func.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  shouldHide: PropTypes.bool.isRequired,
  isDragging: PropTypes.bool.isRequired,
  isAnythingSelected: PropTypes.bool.isRequired,
  //eslint-disable-line
  isResizeHandleHovered: PropTypes.bool.isRequired,
  gutterTop: PropTypes.number.isRequired,
  gutterLeft: PropTypes.number.isRequired,
  gutterHeight: PropTypes.number.isRequired,
  gutterWidth: PropTypes.number.isRequired,
  leftColumn: PropTypes.object,
  //eslint-disable-line
  rightColumn: PropTypes.object,
  //eslint-disable-line
  type: PropTypes.string.isRequired,
  layoutSectionHoverPositionsFrozen: PropTypes.func.isRequired,
  layoutSectionHoverPositionsThawed: PropTypes.func.isRequired
};
export default connect(mapStateToProps, {
  draggingStarted: draggingStartedAction,
  draggingStopped: draggingStoppedAction,
  layoutSectionHoverPositionsFrozen,
  layoutSectionHoverPositionsThawed
})(DragSource(dragTypes.RESIZE_HANDLE, dragSource, dragCollect)(LayoutSectionResizeHandle));